import { jsx as _jsx } from "react/jsx-runtime";
import s from './HeaderItem.module.scss';
export const HeaderItem = ({ children, color, onClick }) => (_jsx("div", { className: s.item, onClick: onClick, style: { backgroundColor: `${color === 'blue' ? '#007AFF' : '#f7f8f9'}` }, children: children }));
